module.exports = __webpack_public_path__ + "static/media/slogan-about.ebb36587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/slogan-about.svg
// module id = 150
// module chunks = 6